import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { stylePropNames, pseudoPropNames } from './style-names';
import { parsePluginStyles } from './parse-styles';
export default function SplitStyles(_ref) {
  var className = _ref.className,
      _ref$mediaQueries = _ref.mediaQueries,
      mediaQueries = _ref$mediaQueries === void 0 ? {} : _ref$mediaQueries,
      plugin = _ref.plugin,
      variant = _ref.variant,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      combinedProps = _objectWithoutPropertiesLoose(_ref, ["className", "mediaQueries", "plugin", "variant", "variants", "visible"]);

  var restProps = {};
  var styleProps = {};

  var isStyleProp = function isStyleProp(prop) {
    return stylePropNames.indexOf(prop) > -1 || pseudoPropNames.indexOf(prop) > -1 || plugin && plugin.styleProps.indexOf(prop) > -1;
  };

  for (var prop in combinedProps) {
    var value = combinedProps[prop];

    if (isStyleProp(prop)) {
      styleProps[prop] = value;
    } else {
      restProps[prop] = value;
    }
  }

  return _objectSpread(_objectSpread({}, restProps), {}, {
    className: className ? "tapestry-react-reset " + className : "tapestry-react-reset",
    css: function css(theme) {
      var propStyles = {};

      for (var _prop in styleProps) {
        var _value = styleProps[_prop];

        if (stylePropNames.indexOf(_prop) > -1 || plugin && plugin.styleProps.indexOf(_prop) > -1) {
          propStyles[_prop] = _value;
        } else if (pseudoPropNames.indexOf(_prop) > -1) {
          propStyles["&:" + _prop] = parsePluginStyles(_value, plugin, theme);
        }
      }

      var baseStyles = parsePluginStyles(propStyles, plugin, theme);
      var mediaQueryStyles = Object.keys(mediaQueries).reduce(function (collection, key) {
        var themeBreakpoint = theme == null ? void 0 : theme.breakpoints[key];
        var query = themeBreakpoint ? typeof themeBreakpoint === 'number' ? "@media screen and (min-width: " + themeBreakpoint + "px)" : themeBreakpoint : key;
        var queryStyles = parsePluginStyles(mediaQueries[key], plugin, theme);

        if (queryStyles.visible !== undefined) {
          queryStyles.display = queryStyles.visible ? baseStyles.display : 'none';
          delete queryStyles.visible;
        }

        collection[query] = queryStyles;
        return collection;
      }, {});

      var mergeVariantsIntoStyles = function mergeVariantsIntoStyles(styles) {
        var variants = styles.variants,
            restStyles = _objectWithoutPropertiesLoose(styles, ["variants"]);

        if (variants) {
          return _objectSpread(_objectSpread({}, restStyles), getVariantStyles(variants));
        } else {
          return styles;
        }
      };

      var getVariantStyles = function getVariantStyles(variants) {
        return Object.keys(variants).reduce(function (mergedStyles, key) {
          var styles = parsePluginStyles(variants[key], plugin, theme);

          if (styles.visible !== undefined) {
            styles.display = styles.visible ? baseStyles.display : 'none';
            delete styles.visible;
          }

          if (variant.includes(key)) {
            return _objectSpread(_objectSpread({}, mergedStyles), mergeVariantsIntoStyles(styles));
          } else if (pseudoPropNames.includes(key)) {
            var _objectSpread2;

            return _objectSpread(_objectSpread({}, mergedStyles), {}, (_objectSpread2 = {}, _objectSpread2[":" + key] = mergeVariantsIntoStyles(styles), _objectSpread2));
          } else {
            return mergedStyles;
          }
        }, {});
      };

      var variantStyles = getVariantStyles(variants);

      if (visible === false) {
        baseStyles.display = 'none';
      }

      return [baseStyles, mediaQueryStyles, variantStyles];
    }
  });
}